import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldSelect } from 'global/components/Form'
import opcoesDiasDSR from '../constants/opcoes-dia-dsr'

export default function CabecalhoTabelaHorarioForm() {
    return (
        <Grid container>
            <Grid item xs={3}>
                <FormField
                    name="codigo"
                    label="Código"
                    placeholder="(gerar automaticamente)"
                    type="number"
                />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="nome"
                    label="Nome da tabela"
                    required
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldSelect
                    label="Dia do DSR"
                    name="diaDescontoDSR"
                    options={opcoesDiasDSR()}
                    required
                />
            </Grid>
        </Grid>
    )
}
